import request from '../../Helpers/Request';

class Webshops {
    constructor(settings) {
        this.settings = settings;
    }

    index() {
        return new Promise((resolve, reject) => {
            request('GET', '/clients/webshops', this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }
}

export default Webshops;
